import { CommonModule, DecimalPipe } from "@angular/common";
import { Component, Inject } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MAT_DIALOG_DATA, MatDialogModule } from "@angular/material/dialog";
import { MatDividerModule } from "@angular/material/divider";
import { MatIconModule } from "@angular/material/icon";
import { ImageUrlDirective } from "@app/directives";

@Component({
  selector: "fh-cart-snapshot-dialog",
  templateUrl: "./cart-snapshot-dialog.component.html",
  styleUrls: ["./cart-snapshot-dialog.component.css"],
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    MatDividerModule,
    DecimalPipe,
    CommonModule,
    ImageUrlDirective
],
})
export class CartSnapshotDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public _data: any) {}

  formatAddress(address: string): string {
    if (!address) return "";
    // The address is stored as: Name#$#$#LastName#$#$#Email#$#$#CountryCode#$#$#Phone#$#$#AddressLine1#$#$#AddressLine2#$#$#City#$#$#State#$#$#PostalCode#$#$#CountryISO#$#$#CountryName
    const parts = address.split("#$#$#");
    if (parts.length >= 11) {
      const [
        name,
        lastName,
        ,
        ,
        ,
        addressLine1,
        addressLine2,
        city,
        state,
        postalCode,
        ,
        countryName,
      ] = parts;
      const fullAddress = [
        `${name} ${lastName}`.trim(),
        addressLine1,
        addressLine2,
        city,
        state,
        postalCode,
        countryName,
      ]
        .filter(Boolean)
        .join(", ");
      return fullAddress;
    }
    return address;
  }
}
